import { render, staticRenderFns } from "./BiobankCard.vue?vue&type=template&id=05c19899&"
import script from "./BiobankCard.vue?vue&type=script&lang=js&"
export * from "./BiobankCard.vue?vue&type=script&lang=js&"
import style0 from "./BiobankCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports